import { useEffect, useState } from "react";
import useApi from "../../../../hooks/use-api";
import { useForm } from "react-hook-form";
import { Button, Spinner } from "react-bootstrap";
import styles from "../../../../styles/transitionplan.module.css";

const TransitionPlanForm = ({FormValues,ApplicationID,ResetFormValues}) => {
    const {patchRequest} = useApi();
    const [feedback, setFeedback] = useState(null);

    const {register,handleSubmit,reset,formState: {isDirty,isSubmitting}} = useForm({defaultValues: FormValues});

    const _handleSubmit = async(items) => {
        setFeedback(null);

        if(items.plancompleted === ''){
            items.plancompleted = null;
        }

        const submitValues = {
            ...items,
            clientapplicationid: ApplicationID
        }
        
        const [data,status] = await patchRequest('UpdateTransitionPlan',submitValues);
        if(status === 200){
            const {clientapplicationid,...resetObj} = data;
        
            ResetFormValues(resetObj);
            setFeedback({
                type: "success",
                message: "The Transition Plan was updated successfully."
            });
        }
        else{
            setFeedback({
                type: "error",
                message: "An error occurred when updating the Transition Plan."
            });
        }
    }

    useEffect(() => {
        reset(FormValues);
    },[FormValues])

    return(
        <form onSubmit={handleSubmit(_handleSubmit)} aria-labelledby="transition-plan-summary-title">
            <div className={`clientCard ${styles.summaryCard}`}>
                <div className={`clientCardInner ${styles.summaryCardInner}`}>
                    <div className={styles.summaryHeader}>
                        <div>
                            <div className={styles.workspaceEyebrow}>Transition plan summary</div>
                            <h2 className={styles.summaryTitle} id="transition-plan-summary-title">Transition Plan</h2>
                            <p className={styles.summaryDescription} id="transition-plan-summary-help">
                                Record the overall transition planning notes before working through needs, goals, services, and providers below.
                            </p>
                        </div>
                    </div>
                    <fieldset className={styles.summaryFieldset} disabled={isSubmitting} aria-describedby="transition-plan-summary-help">
                        <legend className="visually-hidden">Transition plan summary fields</legend>
                        <div className={`${styles.summaryField} ${styles.summaryFieldCompact}`}>
                            <label htmlFor="plancompleted">Plan completed date</label>
                            <input type="date" id="plancompleted" {...register('plancompleted')} max={new Date().toLocaleDateString('en-ca').split('T')[0]} aria-describedby="transition-plan-plancompleted-help" />
                            <small id="transition-plan-plancompleted-help" className={styles.fieldHelpText}>Use the date the plan was completed. Future dates are not allowed.</small>
                        </div>
                        <div className={styles.summaryField}>
                            <label htmlFor="clinicalsocialsummary">Clinical/Social Summary</label>
                            <textarea id='clinicalsocialsummary' rows={4} {...register('clinicalsocialsummary')}/>
                        </div>
                        <div className={styles.summaryField}>
                            <label htmlFor="housingsummary">Housing Summary</label>
                            <textarea id='housingsummary' rows={4} {...register('housingsummary')}/>
                        </div>
                        <div className={styles.summaryField}>
                            <label htmlFor="pretransitionservicesummary">Pre-Transition Service Summary</label>
                            <textarea id='pretransitionservicesummary' rows={4} {...register('pretransitionservicesummary')}/>
                        </div>
                        <div className={styles.summaryField}>
                            <label htmlFor="planfortransitionintocommunity">Plan for transition into community</label>
                            <textarea id='planfortransitionintocommunity' rows={4} {...register('planfortransitionintocommunity')}/>
                        </div>
                    </fieldset>
                    <div className={styles.summaryActionRow}>
                    {feedback && (
                        <div
                            className={`${styles.inlineFeedback} ${feedback.type === "error" ? styles.inlineFeedbackError : styles.inlineFeedbackSuccess}`}
                            role="status"
                            aria-live="polite"
                        >
                            {feedback.message}
                        </div>
                    )}
                    <div className="d-flex justify-content-end mt-2">
                        <Button type="submit" variant="primary" disabled={!isDirty || isSubmitting}>
                            {
                                isSubmitting
                                ?
                                    <>
                                        <Spinner animation='border' size='sm' aria-hidden="true" />
                                        <span className="visually-hidden">Saving transition plan</span>
                                    </>
                                :
                                    <>Save Changes</>
                            }
                        </Button>
                    </div>
                    </div>
                </div>
            </div>
        </form>
    )
}

export default TransitionPlanForm;
